import { NormalTextInputField } from "@/components";
import React from "react";

const MediaCenterFirstTabCMSFormFields = ({
  selectedTab,
  formData,
  isFetching,
  handleTextInputChange,
}) => {
  return (
    <>
      {selectedTab === "section-1" && (
        <>
          {/* Heading */}
          <NormalTextInputField
            isFetching={isFetching}
            labelText="Heading"
            fieldId="news-and-events-heading"
            fieldName="news-and-events-heading"
            placeholderText="Heading"
            inputValue={formData?.["news-and-events-heading"] || ""}
            onChangeTextInputField={handleTextInputChange}
            translateField={true}
          />

          {/* Description */}
          <NormalTextInputField
            isFetching={isFetching}
            isTextArea={true}
            labelText="Description"
            fieldId="news-and-events-description"
            fieldName="news-and-events-description"
            placeholderText="Description"
            inputValue={formData?.["news-and-events-description"] || ""}
            onChangeTextInputField={handleTextInputChange}
            translateField={true}
            extraContainerClasses="mt-5"
          />
        </>
      )}
    </>
  );
};

export default MediaCenterFirstTabCMSFormFields;
